export const CP_CONTENT = {
  hero: {
    kicker: 'Para quem vende parcelado ou recorrente',
    title: 'Seu telefone não devia tocar toda hora só para falar de boleto.',
    subtitle:
      'Com o portal do cliente do 77Gestão, quem compra de você acessa parcelas, histórico financeiro e documentos sozinho, a qualquer hora, sem precisar ligar nem esperar resposta.',
    cta: 'Quero reduzir as ligações repetitivas',
    ctaMessage: 'Quero conhecer o sistema com portal do cliente do 77Gestão',
    urgency: 'Cada ligação sobre 2ª via de boleto é tempo que a sua equipe não está usando para vender ou atender de verdade.',
  },

  statsStrip: [
    { number: '0', label: 'senha para o cliente acessar', icon: 'fa-solid fa-key' },
    { number: '24h', label: 'de acesso disponível ao portal', icon: 'fa-regular fa-clock' },
    { number: '1 link', label: 'por e-mail para entrar', icon: 'fa-solid fa-envelope-open-text' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações? Então você sabe que algo precisa mudar.',
    intro:
      'Empresas que vendem parcelado ou recorrente perdem tempo de equipe todos os dias respondendo as mesmas perguntas sobre pagamento. Não é falta de esforço — é falta da ferramenta certa.',
    items: [
      { icon: 'fa-solid fa-phone-volume', text: 'Telefone tocando o dia todo com cliente perguntando sobre 2ª via de boleto ou parcela.' },
      { icon: 'fa-solid fa-rotate', text: 'A mesma pergunta se repetindo dezenas de vezes por semana, sempre respondida manualmente.' },
      { icon: 'fa-solid fa-file-circle-question', text: 'Cliente perde o boleto e liga de novo, sem ter onde consultar sozinho.' },
      { icon: 'fa-solid fa-magnifying-glass', text: 'Equipe perdendo tempo procurando parcela e histórico de pagamento manualmente para cada ligação.' },
      { icon: 'fa-solid fa-headset', text: 'Atendimento sobrecarregado com perguntas repetitivas em vez de resolver o que realmente importa.' },
    ],
  },

  midCta: {
    text: 'E se o cliente pudesse ver a própria parcela e o próprio boleto sem precisar ligar para ninguém?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do portal do cliente do 77Gestão',
  },

  solution: {
    title: 'Um portal próprio, para o cliente se atender sozinho.',
    intro:
      'O portal do cliente do 77Gestão foi pensado para quem vende parcelado ou recorrente e quer reduzir o volume de ligações repetitivas sem perder o controle do relacionamento.',
    cards: [
      {
        icon: 'fa-solid fa-swatchbook',
        title: 'Portal com a marca da sua empresa',
        text: 'Seu cliente acessa um portal com o seu logo e a sua identidade — não uma tela genérica de terceiros.',
      },
      {
        icon: 'fa-solid fa-key',
        title: 'Login sem senha, por link mágico',
        text: 'O cliente recebe um link por e-mail e entra direto, sem precisar criar nem lembrar senha nenhuma.',
      },
      {
        icon: 'fa-solid fa-file-invoice-dollar',
        title: 'Parcelas e 2ª via de boleto na hora',
        text: 'O cliente consulta parcelas em aberto, pagas e vencidas, e emite a 2ª via sem precisar falar com ninguém.',
      },
      {
        icon: 'fa-solid fa-folder-open',
        title: 'Documentos disponíveis no portal',
        text: 'Contratos, notas e outros documentos relevantes ficam acessíveis ao cliente dentro do próprio portal.',
      },
      {
        icon: 'fa-solid fa-clock-rotate-left',
        title: 'Histórico financeiro completo',
        text: 'O cliente enxerga todo o histórico de compras e pagamentos com a sua empresa, sem precisar pedir extrato.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando o cliente para de precisar ligar',
    intro:
      'Uma empresa que vende parcelado recebia dezenas de ligações por semana só para reenviar boleto e confirmar parcela. A equipe de atendimento não tinha tempo sobrando para outra coisa.',
    stats: [
      { number: '0', label: 'senha para o cliente lembrar' },
      { number: 'Menos', label: 'ligações repetitivas sobre boleto' },
      { number: '24h', label: 'de portal disponível para o cliente' },
    ],
    paragraphs: [
      'Depois da implantação, os clientes passaram a acessar o próprio portal para consultar parcelas, emitir 2ª via de boleto e ver documentos, sem precisar telefonar.',
      'A equipe de atendimento passou a lidar apenas com casos que realmente exigiam uma conversa, reduzindo o volume de ligações repetitivas sobre pagamento.',
    ],
    highlight: 'Resultado: cliente mais autônomo, equipe com menos interrupção e atendimento mais focado no que importa.',
    cta: 'Quero esse nível de controle',
    ctaMessage: 'Vi o resultado e quero entender como ter um portal do cliente no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam o relacionamento com o cliente',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'O cliente enxerga parcelas, histórico e documentos a qualquer hora, sem depender de ligar para a sua empresa.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Você decide o que aparece no portal e mantém o relacionamento organizado, mesmo com o cliente se atendendo sozinho.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'Menos ligação de última hora sobre boleto vencido — o cliente já resolve sozinho antes de virar problema.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o portal do cliente do 77Gestão',
    items: [
      { icon: 'fa-solid fa-link', text: 'Portal integrado ao financeiro — parcela, boleto e histórico sempre atualizados automaticamente.' },
      { icon: 'fa-solid fa-key', text: 'Acesso sem senha, por link mágico, sem fricção nenhuma para o seu cliente.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: o portal sai no ar já configurado com a marca da sua empresa.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e muito bem avaliado.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'O cliente precisa criar uma senha para acessar o portal?',
        answer:
          'Não. O acesso é feito por um link mágico enviado por e-mail — o cliente clica e entra direto, sem precisar cadastrar ou lembrar senha.',
      },
      {
        question: 'Isso substitui totalmente o meu atendimento?',
        answer:
          'Não substitui, reduz. Perguntas repetitivas sobre boleto e parcela passam a ser resolvidas pelo próprio cliente, liberando sua equipe para atendimentos que exigem de fato uma conversa.',
      },
      {
        question: 'Funciona para clientes pessoa física e pessoa jurídica?',
        answer:
          'Sim. O portal funciona tanto para clientes PF quanto PJ cadastrados no sistema, cada um enxergando apenas as próprias informações.',
      },
      {
        question: 'E se o cliente perder o e-mail com o link de acesso?',
        answer:
          'Basta reenviar ou gerar um novo link a partir do sistema — não há senha para recuperar nem processo burocrático de redefinição.',
      },
      {
        question: 'O portal fica com a cara da minha empresa ou do 77Gestão?',
        answer:
          'Com a cara da sua empresa. O portal é personalizado com o seu logo e a sua identidade visual, para o cliente reconhecer que está falando com você.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de atender telefone só para falar de boleto.',
    subtitle:
      'Agende uma demonstração e veja, na prática, como o portal do cliente reduz o volume de ligações repetitivas e dá autonomia para quem compra de você.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do portal do cliente do 77Gestão',
  },

  seo: {
    title: 'Sistema com Portal do Cliente | 77Gestão',
    description:
      'Portal do cliente com login por link mágico, consulta de parcelas, 2ª via de boleto e documentos. Reduza ligações repetitivas no atendimento. Agende uma demo.',
  },
};
